import React, { useEffect, useState } from "react";
import { Building2 } from "lucide-react";
import { toast } from "sonner";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";
import { apiError } from "@/lib/platform";

export const TenantSwitcher = () => {
  const auth = useAuth();
  const [tenants, setTenants] = useState([]);
  const isPA = auth?.user?.grc_role === "platform_admin";

  const mems = auth?.user?.memberships || [];
  useEffect(() => {
    if (isPA) api.get("/platform/tenants").then(({ data }) => setTenants(data.tenants)).catch(() => {});
    else setTenants(mems.map((m) => ({ id: m.tenant_id, name: m.tenant_name })));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isPA, auth?.user?.tenant_id, mems.length]);

  if (!isPA && mems.length < 2) {
    return (
      <div
        data-testid="tenant-name-chip"
        className="hidden lg:flex items-center gap-1.5 px-2.5 py-1 rounded-lg bg-slate-50 border border-slate-200 text-xs text-slate-700 max-w-[220px]"
      >
        <Building2 className="w-3.5 h-3.5 text-slate-500 shrink-0" />
        <span className="truncate">{auth?.user?.tenant_name || "—"}</span>
      </div>
    );
  }

  const onChange = async (id) => {
    try {
      const d = await auth.switchTenant(id);
      toast.success(`Switched to ${d.tenant_name}`);
      window.location.assign("/dashboard");
    } catch (e) {
      toast.error(apiError(e, "Could not switch organization"));
    }
  };

  return (
    <Select value={auth.user.tenant_id} onValueChange={onChange}>
      <SelectTrigger className="h-9 w-[220px] text-xs" data-testid="tenant-switcher">
        <Building2 className="w-3.5 h-3.5 text-slate-500 mr-1" />
        <SelectValue placeholder="Organization" />
      </SelectTrigger>
      <SelectContent>
        {tenants.map((t) => (
          <SelectItem key={t.id} value={t.id} data-testid={`tenant-option-${t.id}`}>
            {t.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
